{
  "el": {
    "issue_status": {
      "actions": {
        "create": "Δημιουργία κατάστασης παρατήρησης"
      },
      "labels": {
        "backup_status": "Κατάσταση αντικατάστασης",
        "customer_status": "Ο πελάτης θα δει",
        "delete_status": "Διαγραφή κατάστασης «{name}»;",
        "delete_status_disclaimer": "Όλες οι παρατηρήσεις με αυτή την κατάσταση θα ανατεθούν ξανά στην κατάσταση που θα επιλέξεις παρακάτω.",
        "inbox_hint": "Προεπιλεγμένη κατάσταση εισερχομένων",
        "internal_status": "Εσωτερική κατάσταση",
        "new_issue_status": "Κατάσταση"
      }
    }
  }
}
